'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useSidebarV2 } from '#pplx/frontend/apps/ask/hooks/sidebar-graphql-v2/context.js';
import { LegacyPinnedItems } from '#pplx/frontend/apps/ask/layout/sidebar/core/lite/internal/LegacyPinnedItems.js';
import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
import React from 'react';
const GraphQLPinnedItems = Dynamic(async () => ({
    default: (await import('#pplx/frontend/apps/ask/layout/sidebar/core/lite/internal/GraphQLPinnedItems.js')).GraphQLPinnedItems,
}));
export const PinnedItems = (props) => {
    const source = useSidebarV2();
    if (source)
        void GraphQLPinnedItems.preload();
    return source ? (_jsx(GraphQLPinnedItems, { ...props, source: source })) : (_jsx(LegacyPinnedItems, { ...props }));
};
//# sourceMappingURL=PinnedItems.js.map